<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content">
    <van-cell-group inset>
      <van-cell title="预约编号" :value="detail.yybh" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="车头号" :value="detail.chetouhao" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="车挂号" :value="detail.cheguahao" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="创建时间" :value="detail.createDate" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="预约时间" :value="detail.pdrq" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="时间段" :value="detail.pdsjd" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="作业类别" :value="detail.txhlb" :title-class="titleClass" :value-class="valueClass"/>


      <van-cell-group v-for="item in detail.ltxtCcpdYyfbList" :key="item">
        <van-cell title="货主" :value="item.huozhu" :title-class="titleClass" :value-class="valueClass"/>
        <van-cell title="提货单位" :value="item.thdw" v-if="(detail.txhlb) == '提货'" :title-class="titleClass" :value-class="valueClass"/>
        <van-cell title="品种" :value="item.pinzhong" :title-class="titleClass" :value-class="valueClass"/>
      </van-cell-group>

      <van-cell title="司机姓名" :value="detail.jsyxx" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="司机身份证" :value="detail.jsysfz" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="押运员姓名" :value="detail.yyyxx" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="押运员身份证" :value="detail.yyysfz" :title-class="titleClass" :value-class="valueClass"/>
      <van-cell title="电子运单状态" :value="detail.sfscdzydStr" :title-class="titleClass" :value-class="valueClass" v-if="(detail.sfscdzydStr)"></van-cell>

      <div class="pdqk" v-if="detail.sfky == 'Y'">{{detail.sysCompanyCode}}</div>
      <div id="qrcode" class="qrcode"></div>
    </van-cell-group>

  </div>

</div>
</template>

<script>
import api from '@/fetch/api'
import QRCode from 'qrcodejs2-fix'
import Nav from "../Public/navTpl.vue"
import {
  Toast
} from 'vant';

export default {
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      id: "",
      detail: [],
      titleClass:"title-class-hq",
      valueClass:"value-class-hq",
    }
  },
  created() {
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getOrderDetail(id);
  },
  methods: {
    getOrderDetail(id) {
      var that = this;
      api.getOrderDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.$data.detail = detail;
          detail.sfscdzydStr = "";
          switch (detail.sfscdzyd) {
            case "1":
              detail.sfscdzydStr = "未上传";
              break;
            case "2":
              detail.sfscdzydStr = "审核中";
              break;
            case "3":
              detail.sfscdzydStr = "已审核";
              break;
          }

          detail.createDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(detail.createDate);
          if (detail.sfky == "Y") {
            var yybh = res.data.yybh;
            that.qrcode(yybh);
          }
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    qrcode(yybh) {
      if (yybh) {
        new QRCode('qrcode', {
          text: yybh // 二维码内容
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.content {
  margin-top: 4.75rem;
  padding-bottom: 1rem;
    .qrcode {
        margin: 0 0.2rem;
        img {
            width: 100%;
        }
    }
    .pdqk {
        text-align: left;
        margin: 0.38rem 0.2rem;
        color: red;
    }
}
</style>
<style lang="css" scoped>
.qrcode>>> img
{
  width: 100%;
}
</style>
